export default __webpack_public_path__ + "static/media/systemHangers1.d144fd24.jpg";